module.exports = __webpack_public_path__ + "img/course_class_student.bb3a227a.png";